var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.actualAdIndex)?_c(_setup.AdUnit,{attrs:{"adPosition":'inlist_' + _setup.actualAdIndex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }